import { render } from "./AdminHeader.vue?vue&type=template&id=18a1ecc8&ts=true"
import script from "./AdminHeader.vue?vue&type=script&lang=ts"
export * from "./AdminHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/timitools.webweb.works/client/timitools/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__